import { HubVisitorDataSource } from './hub.visitor.data.source';

export class HubVisitorFeatureToggle {
  public jobBoard: boolean;
  public calendarViewLayout: boolean;
  public tripPlanner: boolean;
  public itinerary: boolean;
  public placeCalendar: boolean;
  public manualEvents: boolean;
  public eventByGeolocation: boolean;
  public multipleCities: boolean;
  public googleReviews: boolean;
  public facebookPosts: boolean;
  public nearbyPlacesRight: boolean;
  public googlePlaceGeofence: boolean;
  public regionalAccountType: boolean;
  public tour: {
    limit: {
      limited: boolean;
      limitation: number;
    };
    audioTour: boolean;
  };
  public placeCategory: {
    activity: boolean;
    dining: boolean;
    accommodation: boolean;
    shopping: boolean;
    outdoor: boolean;
    entertainment: boolean;
    travel: boolean;
    other: boolean;
    art: boolean;
    thingsToDo: boolean;
  };
  public clientDashboard: {
    placeByGeoLocationTab: boolean;
  };
  public eventTicketUrl: boolean;
  public nearbyEventsInPlace: boolean;
  public nearbyPlacesInEvent: boolean;
  public placeLocationFilter: boolean;
  public eventLocationFilter: boolean;
  public ai: {
    travelBuddy: boolean;
  };

  constructor() {
    this.calendarViewLayout = false;
    this.tripPlanner = true;
    this.itinerary = true;
    this.placeCalendar = true;
    this.manualEvents = true;
    this.eventByGeolocation = true;
    this.multipleCities = false;
    this.googleReviews = true;
    this.facebookPosts = true;
    this.placeCategory = {
      activity: true,
      dining: true,
      accommodation: true,
      shopping: true,
      outdoor: true,
      entertainment: true,
      travel: true,
      other: true,
      art: true,
      thingsToDo: true,
    };
    this.clientDashboard = {
      placeByGeoLocationTab: true,
    };
    this.eventTicketUrl = true;
    this.ai = { travelBuddy: false };
    this.tour = {
      limit: {
        limited: false,
        limitation: 6,
      },
      audioTour: false,
    };
  }
}

export class HubVisitorToggleDataSource {
  public toggle = new HubVisitorFeatureToggle();
  public dataSource = new HubVisitorDataSource();

  // need refactor in v3
  public isKeepTempClosedPlaceInApproved: boolean;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/models/hub/hub.visitor.feature.toggle.ts